import React, { useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/GlobalContext";

const urlPrefix = process.env.REACT_APP_URL_PREFIX;

const ReminderForm = ({
  row,
  history,
  reminder = null,
  onClose,
  onSuccess,
}) => {
  const { userData } = useGlobalContext();

  const isEdit = !!reminder?.reminder_id;

  // Convert API date:
  // 2026-10-01T00:00:00.000Z
  //        ↓
  // 2026-10-01
  const getDateValue = (date) => {
    if (!date) {
      return new Date().toISOString().slice(0, 10);
    }

    return new Date(date).toISOString().slice(0, 10);
  };
  const [form, setForm] = useState({
    reminder_number: reminder?.reminder_number || "",
    reminder_date: getDateValue(reminder?.reminder_date),
    office_or_stage: reminder?.office_or_stage || history?.status_stage || "",
    remarks: reminder?.remarks || "",
    response_remarks: reminder?.response_remarks || "",
    response_date: reminder?.response_date || "",
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.reminder_date) {
      setError("Reminder date is required.");
      return;
    }

    try {
      setSaving(true);

      // ==========================================
      // UPDATE EXISTING REMINDER
      // ==========================================
      if (isEdit) {
        const payload = {
          // reminder_id: reminder.reminder_id,
          reminder_number: form.reminder_number || null,
          reminder_date: form.reminder_date,
          // office_or_stage: form.office_or_stage,
          remarks: form.remarks || null,
          updated_by: userData?.id,
          response_remarks: form?.response_remarks || "",
          response_date: form?.response_date.slice(0, 10) || "",
        };

        await axios.put(
          `${urlPrefix}store/procurements/reminders/${reminder.reminder_id}`,
          payload,
        );

        await onSuccess?.("Reminder updated successfully.");

        return;
      }

      // ==========================================
      // CREATE NEW REMINDER
      // ==========================================
      const payload = {
        reminder_number: form.reminder_number || null,
        reminder_date: form.reminder_date,
        office_or_stage: form.office_or_stage,
        remarks: form.remarks || null,
        created_by: userData?.id,
      };

      await axios.post(
        `${urlPrefix}store/procurements/${row?.case_id}/reminders`,
        payload,
      );

      await onSuccess?.("Reminder created successfully.");
    } catch (error) {
      console.error("Reminder save error:", error);

      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to save reminder.";

      setError(message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {/* BACKDROP */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(0,0,0,0.25)",
          zIndex: 1060,
        }}
        onClick={onClose}
      />

      {/* FORM PANEL */}
      <div
        className="position-fixed bg-white shadow-lg rounded"
        style={{
          width: "650px",
          maxWidth: "95vw",
          maxHeight: "90vh",
          overflowY: "auto",
          top: "50%",
          left: "65%",
          transform: "translate(-50%, -50%)",
          zIndex: 1080,
        }}
      >
        {/* HEADER */}
        <div
          className="d-flex justify-content-between align-items-center px-3 py-3 text-white"
          style={{
            background: "linear-gradient(135deg, #063b87, #0a57bb, #087344)",
          }}
        >
          <div>
            <h6 className="mb-0">
              {isEdit ? "Edit Reminder" : "Create Reminder"}
            </h6>

            <small>Stage: {form.office_or_stage || "-"}</small>
          </div>

          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onClose}
            disabled={saving}
          />
        </div>

        {/* FORM */}
        <div className="p-3">
          {/* ERROR */}
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <div className="d-flex justify-content-between">
            {/* EDIT MODE - REMINDER ID */}
            {isEdit && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Reminder ID</label>

                <input
                  type="text"
                  className="form-control"
                  value={reminder.reminder_id}
                  disabled
                />
              </div>
            )}
            {/* CREATED BY / UPDATED BY */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {isEdit ? "Updated By" : "Created By"}
              </label>

              <input
                type="text"
                className="form-control"
                value={userData?.id || ""}
                disabled
              />
            </div>
          </div>
          <div className="d-flex justify-content-between">
            {/* REMINDER NUMBER */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Reminder Number</label>

              <input
                type="text"
                className="form-control"
                placeholder="REM/2026/002"
                value={form.reminder_number}
                onChange={(e) =>
                  handleChange("reminder_number", e.target.value)
                }
              />
            </div>

            {/* DATE */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Reminder Date</label>

              <input
                type="date"
                className="form-control"
                value={form.reminder_date}
                onChange={(e) => handleChange("reminder_date", e.target.value)}
              />
            </div>
          </div>
          {/* OFFICE / STAGE */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Office / Stage</label>

            <input
              type="text"
              className="form-control"
              value={form.office_or_stage}
              disabled
            />
          </div>

          {/* REMARKS */}
          <div className="mb-3">
            <label className="form-label fw-semibold ">Remarks</label>

            <textarea
              className="form-control"
              rows={4}
              placeholder="Enter reminder remarks..."
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </div>
          {/* RESPONSE */}
          {isEdit && (
            <div>
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Reminder`s Response
                </label>

                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Enter reminder Response..."
                  value={form.response_remarks}
                  onChange={(e) =>
                    handleChange("response_remarks", e.target.value)
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label fw-semibold">Response Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={form.response_date?.slice(0, 10)}
                  onChange={(e) =>
                    handleChange("response_date", e.target.value)
                  }
                />
              </div>
            </div>
          )}

          {/* BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={saving}
            >
              {saving
                ? "Saving..."
                : isEdit
                  ? "Update Reminder"
                  : "Save Reminder"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReminderForm;
